// PieChart.js
import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import axios from 'axios';

const PieChart = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://stage-backend-2024.epravaha.com/api/farmer/count/statewise');
        if (response.data && response.data.length > 0) {
          const chartData = response.data.map(item => ({
            name: item.statename,
            y: item.count
          }));
          setData(chartData);
        } else {
          setError('Empty response data');
        }
      } catch (error) {
        if (error.isAxiosError) {
          setError('Axios error: ' + error.message);
          console.error('Axios error:', error);
        } else {
          setError('Error fetching data: ' + error.message);
          console.error('Error fetching data:', error);
        }
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      {error && (
        <div>
          {error === 'Network Error' ? (
            <div>Network Error: Please check your internet connection and try again.</div>
          ) : (
            <div>Error: {error}</div>
          )}
        </div>
      )}
      {data && (
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              type: 'pie',
              backgroundColor: '#E6E6E6',
            },
            title: {
              text: ''
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: true,
                  format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                }
              }
            },
            series: [{
              name: 'Count',
              data: data
            }]
          }}
        />
      )}
    </div>
  );
};

export default PieChart;
